﻿<template>
  <div class="borrowDetails">
    <div>
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/order/investOrder">{{$t('title.w33')}}</BreadcrumbItem>
        <BreadcrumbItem>{{data.Number}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="agree" v-show="logstate && data.UserType!=0 && data.Id">
      <a
        href="javascript:;"
        @click="protocolShow1(1)"
        v-show="data.UserType===1"
      >{{$t('other.w59')}}</a>
      <a
        href="javascript:;"
        @click="protocolShow1(2)"
        v-show="data.UserType===2"
      >{{$t('other.w59')}}</a>
      <span>/</span>
      <a
        href="javascript:;"
        @click="protocolShow1(3, data, data2 )"
        v-show="data.LoanType==0"
      >{{$t('other.w60')}}</a>
      <a
        href="javascript:;"
        @click="protocolShow1(7, data, data2 )"
        v-show="data.LoanType==1"
      >{{$t('other.w61')}}</a>
    </div>
    <Row class="borrowMsg">
      <Col span="16">
        <div class="borrow">
          <div v-show="data.Amount">
            <p class="color-b">
              <span class="fontsize38 fw500">{{data.Amount | money}}</span>
              {{$t('label.w5')}}
            </p>
            <p>{{$t('label.w2')}}</p>
          </div>
          <div v-show="data.Rate">
            <p class="color-o" v-if="data.AddRate">
              <span class="fontsize38 fw500">{{(data.Rate*100).toFixed(1)}}</span>%
              <span class="fonsize35">+</span>
              <span class="fonstize38">{{(data.AddRate*100).toFixed(1)}}</span>%
            </p>
            <p class="color-o" v-else>
              <span class="fontsize38 fw500">{{(data.Rate*100).toFixed(1)}}</span>%
            </p>
            <p>{{$t('label.w3')}}</p>
          </div>
          <div v-show="data.LoanCycleValue">
            <p class="color-b">
              <span
                class="fontsize38 fw500"
              >{{data.LoanCycleValue<30?data.LoanCycleValue:data.LoanCycleValue/30}}</span>
              {{data.LoanCycleValue<30?$t('label.w15'):$t('label.w14')}}
            </p>
            <p>{{$t('label.w80')}}</p>
          </div>
          <div class="waring">
            <i class="waring-icon"></i>
            {{$t('other.w62')}}
          </div>
        </div>
        <Row class="borrow-type">
          <Col span="16">
            <p>
              {{$t('label.w81')}}
              <span class="color-b">{{$t('option.w55')}}</span>
            </p>
            <p>
              {{$t('label.w82')}}
              <span class="color-b">{{data.Description||$t('option.w36')}}</span>
            </p>
          </Col>
          <Col span="8">
            <p>
              {{$t('label.w83')}}
              <span
                class="color-b"
              >{{data.LoanType==1?$t('option.w64'):$t('option.w65')}}</span>
            </p>
          </Col>
        </Row>
      </Col>

      <!-- 第三方、投资人-->
      <template v-if="data.UserType==0 || data.UserType == 2">
        <!-- 未满标 投资表单 状态 0 -->
        <Col span="8" class="third-borrow" v-if="data.State===0">
          <p class="title">
            <span class="s1">{{$t('label.w84')}}</span>
            <span class="fw500">{{data.LoanResidueAmount | money}} {{$t('label.w5')}}</span>
          </p>
          <p class="title" :style="{marginBottom:'20px'}">
            <span class="s1">{{$t('label.w69')}}</span>
            <span class="color-o s2 fontsize24">
              {{user.AvailableAmount | money}}
              <span class="color-b fontsize14">{{$t('label.w5')}}</span>
            </span>
            <span class="d3">
              <router-link :to="{name:'recharge'}" v-if="logstate===true">{{$t('nav.w9')}}</router-link>
              <!-- 未登录 -->
              <router-link
                :to="{name:'login',query:{back:$route.path}}"
                v-if="logstate===false"
              >{{$t('nav.w48')}}</router-link>
            </span>
          </p>
          <div class="cal-interest">
            <Input
              :placeholder="$t('pl.p23')"
              v-model="investamount"
              @on-blur="blur"
              :disabled="!logstate"
            />
            <span class="unit">{{$t('label.w5')}}</span>
            <div class="result">
              <p>
                <span v-if="investamount">【{{investamount | upmoney}}】</span>
              </p>
              <p>
                <span class="pre">{{$t('label.w231')}}</span>
                <!-- <Icon type="ios-alert-outline" class="pre1" /> -->
                <i class="icon-active pre1" @click="toCheck" />
                <span>{{income | money}}{{$t('label.w5')}}</span>
              </p>
            </div>
          </div>
          <div class="check">
            <Checkbox
              v-model="agree"
              @on-change="agreechange"
              :disabled="!logstate || !investamount "
              v-if="data.LoanType==1"
            >
              <span>{{$t('other.w63')}}</span>
              <a href="javascript:;" @click="protocolShow([2,7])">{{$t('other.w59')}}</a>
              <span>/</span>
              <a href="javascript:;" @click="protocolShow([7,2])">{{$t('other.w61')}}</a>
            </Checkbox>
            <Checkbox v-model="agree" @on-change="agreechange" :disabled="!logstate" v-else>
              <span>{{$t('other.w63')}}</span>
              <a href="javascript:;" @click="protocolShow([2,3])">{{$t('other.w59')}}</a>
              <span>/</span>
              <a href="javascript:;" @click="protocolShow([3,2])">{{$t('other.w60')}}</a>
            </Checkbox>
          </div>
          <Button
            :disabled="!logstate||!investamount||!agree"
            @click="openModal('invest')"
          >{{$t('btn.b38')}}</Button>
        </Col>

        <!-- 满标及后续 状态 1,2,7,100,200 -->
        <Col
          span="8"
          class="borrow-time state"
          v-if="[1,2,7,100,200].indexOf(data.State)>-1"
          :class="{
           's1':data.State===1||data.State===100,
           's2':data.State===2,
           's4':data.State===7,
           's3':data.State===200,
          }"
        >
          <Row class="unlogin-msg">
            <Col span="12">
              <p>{{$t('label.w86')}}</p>
              <p>{{$t('label.w87')}}</p>
              <p>{{$t('label.w88')}}</p>
            </Col>
            <Col span="12" class="color-b">
              <p class="p-r">{{data.BeginUseTime==''? '0'+$t('label.w15'):data.BeginUseTime}}</p>
              <p class="p-r">{{data.BeginAt=='' ? '0000-00-00':data.BeginAt}}</p>
              <p
                class="p-r"
              >{{$t('option.w66').replace('{%}',(InvestmentManCount=='' ? '0':InvestmentManCount))}}</p>
            </Col>
          </Row>
        </Col>
      </template>

      <!-- 借款人 -->
      <template v-if="data.UserType===1">
        <!-- 未满标 状态 0 -->
        <Col span="8" v-if="data.State===0" class="borrower">
          <p class="detail">
            <span class="d1">{{$t('label.w89')}}</span>
            <span class="d2 color-b">{{data.CreatedAt}}</span>
            <span class="color-o d3">{{data.StateName}}</span>
          </p>
          <!-- <p class="detail">
            <span class="d1">{{$t('label.w88')}}</span>
            <span class="d2 color-b">{{$t('option.w66').replace('{%}',InvestmentManCount)}}</span>
            <span class="d3"><router-link :to="{name:'recharge'}">{{$t('nav.w9')}}</router-link></span>
          </p>-->
          <p class="detail" :style="{marginBottom:'2px'}">
            <span class="d1">{{$t('label.w18')}}</span>
            <span
              class="d2 color-b"
              :style="{width:'75%'}"
            >¥{{data.CurrentAmount | money}} / ¥{{data.Amount | money}}</span>
          </p>
          <p>
            <Progress
              :percent="data.Progress<1 && data.Progress!=0 ? 1:data.Progress"
              hide-info
              stroke-color="#749EFC"
            />
          </p>
          <p class="stoptime">
            <span class="icon">{{$t('label.w90')}}</span>
            <span class="color-b">{{data.ExpiredAt}}</span>
          </p>
          <div class="op-btn">
            <Button @click="openModal('cancel')">{{$t('btn.b39')}}</Button>
            <Button class="btn-bg" @click="openModal('addrate')">{{$t('btn.b40')}}</Button>
          </div>
        </Col>

        <!-- 待还款 已逾期 状态 1,100 ,6 -->
        <Col span="8" class="reimbursement" v-if="[1,100,6].indexOf(data.State)>-1">
          <p class="time">
            <span class="s1">{{$t('label.w87')}}</span>
            <span class="s2">{{data.BeginAt}}</span>
            <span class="s3 color-r">{{data.StateName}}</span>
          </p>
          <p class="time" :style="{marginBottom:'35px'}">
            <span class="s1">{{$t('label.w91')}}</span>
            <span class="s2 color-r">
              {{data.NextRepayAt}}
              <span
                v-show="data.ResidueTime"
              >[{{$t('other.w64').replace('{%}',data.ResidueTime)}}]</span>
            </span>
          </p>
          <Row>
            <Col span="12" class="num">
              <p>
                <span class="n1">{{data.PhaseAmount | money}}</span>
                <span class="color-b">元</span>
              </p>
              <p>{{$t('label.w56')}}</p>
              <Button @click="openModal('repay_2')" v-if="data.State!=6">{{$t('btn.b41')}}</Button>
            </Col>
            <Col span="12" class="num" :style="{paddingLeft:'30px'}">
              <p>
                <span class="n1">{{data.PhaseManagementFee | money}}</span>
                <span color-b>{{$t('label.w5')}}</span>
              </p>
              <p>{{$t('label.w92')}}</p>
              <Button
                class="btn1"
                @click="openModal('repay_1')"
                v-if="data.State!=6"
              >{{$t('btn.b42')}}</Button>
            </Col>
          </Row>
        </Col>

        <!-- 已还款 状态 2,7,200 -->
        <Col
          span="8"
          class="borrow-time state"
          v-if="[2,7,200].indexOf(data.State)>-1"
          :style="{paddingRight:'50px'}"
          :class="{
          's2':data.State===2,
          's4':data.State===7,
          's3':data.State===200,
        }"
        >
          <Row class="title">
            <Col span="7">
              <p>{{$t('label.w87')}}</p>
              <p>{{$t('label.w93')}}</p>
            </Col>
            <Col span="17">
              <p class="color-b">{{data.BeginAt}}</p>
              <p class="color-r">{{data.RePayEndTime}}</p>
            </Col>
          </Row>
          <div class="money">
            <div>
              <p class="color-b">
                <span class="fontsize28">{{data.TotalAmountInterest | money}}</span>
                {{$t('label.w5')}}
              </p>
              <p>{{$t('label.w94')}}</p>
            </div>
            <div>
              <p class="color-b">
                <span class="fontsize28">{{data.BeenRepayManagementFeeAmount | money}}</span>元
              </p>
              <p>{{$t('label.w95')}}</p>
            </div>
          </div>
        </Col>
      </template>

      <!-- 不区分角色 -->
      <!-- 已撤销、流标 状态 3,4 -->
      <Col
        span="8"
        v-if="[3,4].indexOf(data.State)>-1"
        class="borrow-time undo state"
        :class="{
        's5':data.State===3,
        's6':data.State===4,
      }"
      >
        <p class="undo-desc">
          <span>{{$t('label.w89')}}</span>
          <span>{{data.CreatedAt}}</span>
        </p>
        <p class="undo-desc" :style="{marginBottom:'30px'}">
          <span>{{$t('label.w88')}}</span>
          <span>{{InvestmentManCount}}</span>
        </p>
        <p class="undo-desc" :style="{marginBottom:'4px'}">
          <span>{{$t('label.w18')}}</span>
          <span>¥{{data.CurrentAmount | money}} / ¥{{data.Amount | money}}</span>
        </p>
        <p>
          <Progress
            :percent="data.Progress<1 && data.Progress!=0 ? 1:data.Progress"
            hide-info
            stroke-color="#749EFC"
          />
        </p>
      </Col>
    </Row>
    <!-- 未登录 -->
    <div class="unlogin" v-if="logstate===false">
      <div class="img"></div>
      <p>
        <router-link :to="{name:'login',query:{back:$route.path}}">{{$t('nav.w48')}}</router-link>
        <span>{{$t('other.w65')}}</span>
        <router-link :to="{name:'register'}">{{$t('nav.w49')}}</router-link>
        <span>{{$t('other.w66')}}</span>
      </p>
    </div>
    <!-- 已登录 -->
    <div v-if="logstate===true && data.LoanType==0" class="domainMsg">
      <h3>{{$t('title.w34')}}</h3>
      <div class="dm-list scrollbar">
        <Datatable
          :static="LoanPledgeList"
          :th="[$t('label.w96'),$t('label.w97'),$t('label.w98')+'/'+$t('label.w99'),$t('label.w100')]"
          v-slot="{item}"
          minHeight="auto"
          max-height="252px"
          v-if="
            data.UserType===1||
            data.UserType===2||
            (data.UserType===0&&data.Progress<100)
          "
        >
          <tr>
            <td>
              {{item.PledgeName}}
              <a
                style="marginLeft:6px"
                :href="`https://www.62.com/DnRegister/DnWhois?domain=${item.PledgeName}`"
                target="_blank"
              >[{{$t('btn.b21')}}whois]</a>
            </td>
            <td>{{item.DomainTypeName}}</td>
            <td>￥{{item.CreditAmount | money}} / {{item.CurrentPercent}}%</td>
            <td>{{item.LoanSchemePercent}}%</td>
          </tr>
        </Datatable>
        <div class="thrid-bg" v-else>
          <div class="img"></div>
          <p>{{$t('msg.m93')}}</p>
        </div>
      </div>
    </div>
    <div v-if="logstate===true" class="detailsDesc">
      <div class="nav">
        <span :class="{active:state==1}" @click="state=1">{{$t('nav.w50')}}</span>
        <span
          :class="{active:state==2}"
          @click="state=2"
          v-show="InvestmentSchemeList.length"
        >{{$t('nav.w51')}}</span>
        <span
          :class="{active:state==3}"
          @click="state=3"
          v-show="RepaymentHistoryList.length"
        >{{$t('nav.w52')}}</span>
        <span :class="{active:state==4}" @click="state=4">{{$t('nav.w36')}}</span>
      </div>
      <div class="nav-content">
        <div v-show="state==1">
          <BorrowInfo
            :data="LoanUser"
            :chart="PledgeScaleList"
            :idType="data.UserType"
            :state="data.State"
          />
          <CreditRecord :data="IntegrityList" />
        </div>
        <div class="invest-list" v-show="state==2&&InvestmentSchemeList.length">
          <table>
            <thead>
              <tr>
                <th>{{$t('label.w101')}}</th>
                <th>{{$t('label.w1')}}</th>
                <th>{{$t('label.w102')}}</th>
                <!-- <th>{{$t('label.w53')}}</th> -->
              </tr>
            </thead>
            <tbody class="scrollbar">
              <tr v-for="(v,i) in InvestmentSchemeList" :key="i">
                <td
                  v-if="data.UserType==0 || (data.UserType==1 && data.ManagerLogin==false)"
                >{{v.RealName | name}}</td>
                <td v-else>{{v.RealName}}</td>
                <td>{{v.Amount | money}}{{$t('label.w5')}}</td>
                <td>{{v.CreatedAt}}</td>
                <!-- <td>{{v.StateName}}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="borrow-list" v-show="state==3&&RepaymentHistoryList.length">
          <table>
            <thead>
              <tr>
                <th>{{$t('label.w54')}}</th>
                <th>{{$t('label.w58')}}</th>
                <th>{{$t('label.w59')}}/{{$t('label.w66')}}</th>
                <th v-if="data.UserType==1">{{$t('label.w55')}}/{{$t('label.w66')}}</th>
                <th>{{$t('label.w61')}}</th>
                <th>{{$t('label.w62')}}</th>
              </tr>
            </thead>
            <tbody class="scrollbar">
              <tr v-for="(v,i) in RepaymentHistoryList" :key="i">
                <td>{{v.Phase}}</td>
                <td>{{v.RepayAt}}</td>
                <td>¥ {{v.PhaseRepayAmount | money}} / ¥ {{v.OverdueAmount | money}}</td>
                <td
                  v-if="data.UserType==1"
                >¥ {{v.ManagementFee | money}} / ¥ {{v.ManagementFeeOverdueAmount | money}}</td>
                <td v-if="v.PauseAt==''">{{v.StateName}}</td>
                <td v-else>
                  <span>{{v.StateName}}</span>
                  <span class="pause-icon">
                    <Icon type="md-alert" />
                    <span class="time">{{$t('msg.m94')}}{{v.PauseAt}}</span>
                  </span>
                </td>
                <td>{{v.RepayedAt}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-show="state==4">
          <CommonProblem />
        </div>
      </div>
    </div>
    <Invest
      :data="data"
      :user="user"
      ref="Invest"
      :fees="safe.InvestManagementFeeRate"
      :days="days"
    />
    <Cancel ref="Cancel" @done="refresh" />
    <Addrate ref="Addrate" @done="refresh" />
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false" />
    <Protocoldis ref="Protocol1" :data="data" />
    <Repay ref="Repay" @done="refresh" />
    <Incomes ref="Incomes" />
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import Incomes from "./modal/incomes";
import BorrowInfo from "./modal/borrowInfo";
import CommonProblem from "./modal/commonProblem";
import CreditRecord from "./modal/creditRecord";
import Invest from "./modal/invest";
import Cancel from "../order/modal/cancel";
import Addrate from "../order/modal/addrate";
import Protocol from "@/components/protocolModal";
import Protocoldis from "@/components/protocolDisplay";
import Repay from "../order/modal/repay";
export default {
  components: {
    Datatable,
    Incomes,
    BorrowInfo,
    CommonProblem,
    CreditRecord,
    Invest,
    Cancel,
    Addrate,
    Protocol,
    Protocoldis,
    Repay,
  },
  data() {
    return {
      state: 1,
      data: {},
      data2: {},
      user: {},
      investamount: "",
      agree: false,
      // 详情
      InvestmentManCount: 0, //投资人数
      LoanPledgeList: [], //质押域名信息
      LoanUser: {}, //借款人信息
      PledgeScaleList: [], //借款人域名品类占比统计
      PledgeCount: 0, //持有域名总数
      InvestmentSchemeList: [], //投资记录信息
      RepaymentHistoryList: [], //还款记录信息
      IntegrityList: [], //还款信用信息
      // fee: 0.001, //投资利率
    };
  },
  mounted() {
    this.getData();
    this.getDetail();
    this.getMyinfo();
  },
  methods: {
    //查看收益窗口
    toCheck() {
      this.$refs.Incomes.value = true;
    },
    back() {
      this.$router.replace({ name: "invest" });
    },
    // 获取基本信息
    async getData() {
      let id = this.$route.params.id;
      if (!id) return this.back();
      let res = await this.$axios.get(
        "/Member/RZJLoan/LoanSchemeDetail?loanSchemeId=" + id
      );
      if (res.err) {
        res.throw();
        return this.back();
      }
      this.data = res;
      // console.log(res);
    },
    // 获取详细信息
    async getDetail() {
      let id = this.$route.params.id;
      if (!id) return;
      let res = await this.$axios.get(
        "/Member/RZJLoan/LoanSchemeDetailRecord?loanSchemeId=" + id
      );
      if (res.err) {
        res.throw();
        return;
      }
      this.data2 = res;
      this.InvestmentManCount = res.InvestmentManCount;
      this.LoanPledgeList = res.LoanPledgeList;
      this.LoanUser = res.LoanUser;
      this.PledgeScaleList = res.PledgeScaleList;
      this.PledgeCount = res.PledgeCount;
      this.InvestmentSchemeList = res.InvestmentSchemeList;
      this.RepaymentHistoryList = res.RepaymentHistoryList;
      this.IntegrityList = res.IntegrityList;
    },
    // 获取当前用户信息
    async getMyinfo() {
      if (this.logstate) {
        let res = await this.$axios.get("/Member/RZJLoan/InvestUserInfo");
        this.user = res;
      }
    },
    blur() {
      let v = this.investamount
        .replace(/\..*/, "")
        .replace(/[^\d]/g, "")
        .replace(/^0+/, "");
      if (v == "") return;
      v = Number(v);
      if (v > this.user.AvailableAmount) v = this.user.AvailableAmount;
      if (v > this.data.LoanResidueAmount) v = this.data.LoanResidueAmount;
      v = v - (v % 100);
      this.investamount = v.toString();
    },
    openModal(t) {
      switch (t) {
        case "invest":
          this.$refs.Invest.amount = this.investamount;
          this.$refs.Invest.modal = true;
          break;
        case "cancel":
          this.$refs.Cancel.item = this.data;
          this.$refs.Cancel.modal = true;
          break;
        case "addrate":
          this.$refs.Addrate.item = this.data;
          this.$refs.Addrate.modal = true;
          break;
        case "repay_1":
          this.$refs.Repay.type = 1;
          this.$refs.Repay.item = this.data;
          this.$refs.Repay.modal = true;
          break;
        case "repay_2":
          this.$refs.Repay.type = 2;
          this.$refs.Repay.item = this.data;
          this.$refs.Repay.modal = true;
          break;
      }
    },
    // 刷新
    refresh() {
      this.getData();
      this.getDetail();
    },
    protocolShow(arr) {
      this.$refs.Protocol.type = arr;
      this.$refs.Protocol.modal = true;
    },
    protocolShow1(type, data, data2) {
      this.$refs.Protocol1.type = type;
      this.$refs.Protocol1.modal = true;
      this.$refs.Protocol1.agreeData = data;
      this.$refs.Protocol1.personMsg = data2;
    },
    agreechange() {
      if (!this.agree) return;
      if (this.data.LoanType == 1) {
        this.protocolShow([2, 7]);
      } else {
        this.protocolShow([2, 3]);
      }
      this.openModal("invest");
    },
  },
  computed: {
    logstate() {
      return this.$store.state.user.logstate;
    },
    safe() {
      return this.$store.state.user.safe;
    },
    // 投资天数
    days() {
      if (this.data && this.data.LoanCycleValue >= 30) {
        return this.data.TotalPhase;
      } else {
        return this.data.LoanCycleValue / 30;
      }
    },
    //收益
    income() {
      if (this.data.LoanType == "1") {
        return (
          ((this.investamount * (this.data.AddRate + this.data.Rate)) / 12) *
          (this.data.LoanCycleValue / 30)
        );
      } else {
        return (
          ((this.investamount * (this.data.AddRate + this.data.Rate)) / 12) *
            (this.data.LoanCycleValue / 30) -
          this.investamount * this.safe.InvestManagementFeeRate * this.days
        );
      }
    },
  },
  watch: {
    $route(v) {
      this.refresh();
    },
    logstate(v) {
      if (v) this.getMyinfo();
    },
  },
};
</script>

<style lang="less" scoped>
.borrowDetails {
  margin-bottom: 30px;
  position: relative;
  .fontsize38 {
    font-size: 38px;
  }
  .fontsize35 {
    font-size: 35px;
  }
  .fontsize24 {
    font-size: 24px;
  }
  .fontsize14 {
    font-size: 14px;
  }
  .color-o {
    color: #ff6106;
  }
  .color-r {
    color: #f5222d !important;
  }
  .color-b {
    color: #232325;
  }
  .fw500 {
    font-weight: 500;
  }
  .agree {
    position: absolute;
    right: 0;
    top: 15px;
  }
  .borrowMsg {
    width: 100%;
    height: 292px;
    margin: 10px 0;
    border-radius: 8px;
    background: #fff;
    font-size: 14px;
    color: #7b7b7c;
    .borrow {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-right: 1px solid #f0f1f9;
      border-bottom: 1px solid #f0f1f9;
      border-radius: 8px 0 0 0;
      width: 100%;
      height: 152px;
      background: #fcfcfc;
      text-align: left;
      .waring {
        position: absolute;
        top: 0;
        right: 0;
        width: 170px;
        height: 24px;
        border-radius: 0px 0px 0px 10px;
        background: #5e8ffc;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
        padding-left: 5px;
        .waring-icon {
          display: inline-block;
          width: 14px;
          height: 14px;
          background-image: url("../../assets/borrow/pic_info@2x.png");
          background-position: 0 0;
          background-size: cover;
          vertical-align: text-top;
        }
      }
    }
    .borrow-type {
      text-align: left;
      border-right: 1px solid #f0f1f9;
      padding: 30px 50px;
      line-height: 40px;
      .color-b {
        margin-left: 10px;
      }
    }
    .third-borrow {
      padding: 30px 30px 0;
      color: #333;
      .title {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
        }
        a {
          display: inline-block;
          width: 52px;
          text-align: center;
          line-height: 26px;
          border-radius: 4px;
          border: 1px solid rgba(106, 152, 255, 1);
        }
        .s1 {
          width: 25%;
          color: #7b7b7c;
        }
        .s2 {
          width: 60%;
        }
      }
      .cal-interest {
        position: relative;
        color: #232325;
        .unit {
          position: absolute;
          top: 10px;
          right: 10px;
        }
        /deep/.ivu-input {
          padding-right: 25px;
        }
        .result {
          display: flex;
          margin: 10px 0 15px 0;
          padding-right: 10px;
          justify-content: space-between;
          .pre {
            color: #7b7b7c;
            // margin-right: 30px;
          }
          .pre1 {
            margin: 0 20px 0 10px;
            font-size: 16px;
            color: red;
          }
          .icon-active {
            display: inline-block;
            position: relative;
            width: 14px;
            height: 14px;
            background: url("../../assets/borrow/pic_info@2x.png") no-repeat;
            background-size: cover;
            background-position: -14px 0;
            // &::before {
            //   display: none;
            //   content: "";
            //   position: absolute;
            //   left: 0px;
            //   top: -12px;
            //   width: 0;
            //   height: 0;
            //   border-left: 8px solid transparent;
            //   border-right: 8px solid transparent;
            //   border-top: 8px solid rgba(255, 255, 255, 1);
            //   z-index: 5;
            // }
            .desc {
              display: none;
              width: 162px;
              padding: 10px 0 15px 10px;
              box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
              border-radius: 4px;
              background: #fff;
              font-style: normal;
              font-size: 14px;
              color: #000000;
              position: absolute;
              left: -25px;
              bottom: 26px;
              z-index: 5;
            }
            // &:hover {
            //   &::before {
            //     display: block;
            //   }
            //   .desc {
            //     display: block;
            //   }
            // }
          }
        }
      }
      .check {
        color: #7b7b7c;
      }
      /deep/.ivu-btn {
        background: #5e8ffc;
        color: #fff;
        width: 100%;
        margin-top: 10px;
      }
    }
    .borrow-time {
      position: relative;
      height: 100%;
      padding: 20px 0 20px 30px;
      .title {
        line-height: 40px;
      }
      .money {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        .fontsize28 {
          font-size: 28px;
        }
      }
      // 第三方登录已还款
      .unlogin-msg {
        color: #7b7b7c;
        padding: 10px 30px 0 0;
        p {
          margin-bottom: 20px;
        }
        .p-r {
          text-align: right;
        }
      }
    }

    // 撤销
    .undo {
      padding-right: 38px;
      .undo-desc {
        margin-bottom: 20px;
        span:last-child {
          margin-left: 40px;
          color: #333333;
        }
      }
    }

    //借款人页面详情
    .borrower {
      padding: 30px 30px;
      .detail {
        margin-bottom: 35px;
        color: #7b7b7c;
        span {
          display: inline-block;
        }
        .d1 {
          width: 25%;
        }
        .d2 {
          width: 42%;
        }
        .d3 {
          text-align: right;
          width: 33%;
        }
        a {
          display: inline-block;
          width: 52px;
          text-align: center;
          line-height: 26px;
          border-radius: 4px;
          border: 1px solid rgba(106, 152, 255, 1);
        }
      }
      .stoptime {
        margin-top: 35px;
        .icon {
          margin-right: 20px;
          position: relative;
          padding-left: 20px;
          &::before {
            content: "";
            width: 14px;
            height: 14px;
            background: url("../../assets/borrow/pic_info@2x.png") no-repeat;
            background-size: cover;
            background-position: -14px 0px;
            position: absolute;
            left: 0;
            bottom: 1px;
          }
        }
      }
      .op-btn {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        /deep/.ivu-btn {
          width: 123px;
          color: #5e8ffc;
          border: 1px solid rgba(106, 152, 255, 1);
        }
        .btn-bg {
          background: #5e8ffc;
          border: 0;
          color: #fff;
        }
      }
    }
    // 已逾期 待还款
    .reimbursement {
      padding: 30px 34px 0 30px;
      .time {
        margin-bottom: 20px;
        span {
          display: inline-block;
        }
        .s1 {
          width: 30%;
        }
        .s2 {
          width: 50%;
          color: #232325;
        }
      }
      .num {
        .n1 {
          color: #232325;
          font-size: 28px;
          font-weight: 500;
          font-family: DIN-Medium;
        }
        .ivu-btn {
          margin-top: 30px;
          width: 123px;
          height: 40px;
          color: #5e8ffc;
          line-height: 35px;
          border-radius: 8px;
          border: 1px solid rgba(106, 152, 255, 1);
        }
        .btn1 {
          color: #fff;
          background: #5e8ffc;
          border: 0;
        }
      }
    }
  }
  .unlogin {
    border-radius: 8px;
    margin: 30px 0;
    height: 302px;
    background: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img {
      width: 100%;
      height: 130px;
      background: url("../../assets/borrow/pic_qs1@2x.png") no-repeat center;
      background-size: 197px 197px;
    }
    p {
      margin-top: 30px;
      color: #7b7b7c;
      font-size: 14px;
      a {
        margin: 0 5px;
      }
    }
  }
  .domainMsg {
    margin: 30px 0;
    h3 {
      font-size: 18px;
      font-weight: 500;
      color: rgba(35, 35, 37, 1);
      margin-bottom: 13px;
    }
    .dm-list {
      position: relative;
      .thrid-bg {
        background: #fff;
        width: 100%;
        min-height: 270px;
        text-align: center;
        font-size: 14px;
        color: #7b7b7c;
        border-right: 1px solid #f0f1f9;
        z-index: 5;
        .img {
          width: 100%;
          height: 230px;
          background: url("../../assets/borrow/pic_qs2@2x.png") no-repeat center;
          background-size: 197px 197px;
        }
        p {
          margin-top: -15px;
        }
      }
    }
  }
  .detailsDesc {
    .nav {
      width: 1200px;
      height: 74px;
      background: rgba(252, 252, 252, 1);
      border-radius: 8px 8px 0px 0px;
      padding-left: 20px;
      margin-bottom: 1px;
      span {
        display: inline-block;
        width: 114px;
        height: 74px;
        line-height: 74px;
        font-size: 18px;
        color: rgba(123, 123, 124, 1);
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: #6c95ee;
        border-bottom: 4px solid #6c95ee;
      }
    }
    .nav-content {
      background: #fff;
    }
    table tbody {
      display: block;
      max-height: 366px;
      overflow-y: auto;
    }
    table thead tr {
      padding-right: 15px;
    }
    table thead,
    tbody tr {
      display: table;
      width: 100%;
      height: 60px;
      table-layout: fixed;
      border-bottom: 1px solid #f0f1f9;
    }

    table thead {
      //   width: calc( 100% - 1em );
      height: 38px;
    }
    table tbody td {
      padding: 10px 15px;
      text-align: center;
      height: 60px;
      font-size: 14px;
      color: #333333;
      &:first-child {
        text-align: left;
        padding-left: 30px;
      }
    }
    tr:last-child {
      border-bottom: 0;
    }
    table thead th {
      padding: 10px 15px;
      height: 38px;
      font-size: 14px;
      background: rgb(53, 110, 236);
      opacity: 0.7;
      text-align: center;
      color: #fff;
      &:first-child {
        text-align: left;
        padding-left: 30px;
      }
    }
    .pause-icon {
      margin-left: 3px;
      color: #ff6106;
      position: relative;
      cursor: pointer;
      &:hover {
        .time {
          display: inline-block;
        }
        &:after {
          display: block;
        }
      }
      .time {
        position: absolute;
        left: 25px;
        top: -12px;
        width: 75px;
        height: 36px;
        border-radius: 4px;
        background: #999;
        color: #fff;
        font-size: 12px;
        display: none;
      }
      &:after {
        display: none;
        content: "";
        position: absolute;
        left: 5px;
        top: -2px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid #999;
      }
    }
  }
}
// 状态
.state {
  &:after {
    content: "";
    width: 190px;
    height: 144px;
    background: no-repeat;
    background-size: cover;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  // 还款中
  &.s1:after {
    background-image: url("../../assets/borrow/pic_repayment@2x.png");
  }
  // 已还款
  &.s2:after {
    background-image: url("../../assets/borrow/pic_Reimbursement@2x.png");
  }
  //逾期还款
  &.s3:after {
    background-image: url("../../assets/borrow/pic_overdue@2x.png");
  }
  //违约还款
  &.s4:after {
    background-image: url("../../assets/borrow/pic_break@2x.png");
  }
  //流标
  &.s5:after {
    background-image: url("../../assets/borrow/pic_abortive@2x.png");
  }
  // 撤销
  &.s6:after {
    background-image: url("../../assets/borrow/pic_rescinded@2x.png");
  }
}
</style>
